/**
 * Reload the app from the network. After a deploy, a stale service worker can keep serving the previous build
 * (and its now-deleted lazy chunks) so a plain `location.reload()` lands on the same error again. Drop the service
 * worker and its caches first, then reload. Best effort: any failure still ends in a reload.
 */
export async function reloadFresh(): Promise<void> {
  try {
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
    }
    if ("caches" in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((key) => caches.delete(key)));
    }
  } catch {
    // fall through to the reload
  } finally {
    window.location.reload();
  }
}
